import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const authData = JSON.parse(localStorage.getItem('auth-data')) || null

const state = {
  authData
}

const auth = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default auth
